import { getEntries } from 'services/content';
import { normalizeLocale } from 'services/locale';

export const LOAD_TESTIMONIALS = 'LOAD_TESTIMONIALS';

const defaultState = [];

export default function testimonials(state = defaultState, action) {
  switch (action.type) {
    case LOAD_TESTIMONIALS:
      return action.payload;
    default:
      return state;
  }
}

export function loadTestimonials(locale) {
  const normalizedLocale = normalizeLocale(locale);
  const localStorageKey = `testimonials:${normalizedLocale}`;
  const lsTestimonials = localStorage.getItem(localStorageKey);
  return dispatch => {
    return lsTestimonials
      ? dispatch({
        type: LOAD_TESTIMONIALS,
        payload: JSON.parse(lsTestimonials)
      })
      : getEntries({ content_type: 'testimonial', locale: normalizedLocale }).then(function(response) {
        localStorage.setItem(localStorageKey, JSON.stringify(response.data.items));
        dispatch({
          type: LOAD_TESTIMONIALS,
          payload: response.data.items
        });
      });
  };
}
